import angular from 'angular';
import ngRoute from 'angular-route';
import viewCartComponent from './view-cart.component';
import viewCartModelResolver from './view-cart-resolver';
import viewCartOptions from './view-cart-options/view-cart-options.component';
import viewCartHeadingsComponent from './view-cart-headings/view-cart-headings.component';
import viewCartErrorMessagesComponent from './view-cart-error-messages/view-cart-error-messages.component';
import viewCartItemsComponent from './view-cart-items/view-cart-items.component';
import viewCartSummaryComponent from './view-cart-summary/view-cart-summary.component';

let viewCartModule = angular.module('view-cart', [
    ngRoute
])

.config(($routeProvider) => {
    "ngInject";

    $routeProvider.when('/bathrooms/cart/', {
        template: '<view-cart view-cart-model="$resolve.viewCartModel"></view-cart>',
        resolve: viewCartModelResolver
    });
})

.component('viewCart', viewCartComponent)
.component('viewCartOptions', viewCartOptions)
.component('viewCartHeadings', viewCartHeadingsComponent)
.component('viewCartErrorMessages', viewCartErrorMessagesComponent)
.component('viewCartItems', viewCartItemsComponent)
.component('viewCartSummary', viewCartSummaryComponent);

export default viewCartModule;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart.js